// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__I8xXq","dragIcon":"SortableItem_dragIcon__2Tbt2","disabled":"SortableItem_disabled__zCutD"};